// ActivityWidget.js
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@iconify/react';

const ActivityContainer = styled.div`
  margin: 6px;
  background-color: white;
  border-radius: 12px;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  width: calc(100% - 12px);
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  
  svg {
    width: 24px;
    height: 24px;
    padding: 4px;
    border-radius: 50%;
    background-color: #FF6B6B;
    
    path {
      fill: white;
    }
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const ActivityTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
`;

const RewardText = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: 500;
`;

// Removed unused styled component

const GoButton = styled.button`
  background-color: black;
  color: white;
  border: none;
  border-radius: 14px;
  padding: 6px 18px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  min-width: 50px;
`;

const ActivityWidget = () => {  
  return (
    <ActivityContainer>      
      <LeftContent>
        <div className="gift-icon icon-container dark-bg interactive-icon">
          <Icon icon="famicons:gift-sharp" width="30" height="30" color="#FF6B6B" />
        </div>
        <TextContent>
          <ActivityTitle>Activity</ActivityTitle>
          <RewardText>+100 $PXL</RewardText>
        </TextContent>
      </LeftContent>
      <GoButton className="interactive-icon">GO</GoButton>
    </ActivityContainer>
  );
};

export default ActivityWidget;
